export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-B-d1f104c6f05c6a5b270e2d9b3dcbaa31.jpg";